import { Directive, input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, type ValidationErrors, type Validator } from '@angular/forms';

@Directive({
  selector: '[authMatchingPassword]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MatchingPasswordValidatorDirective, multi: true }]
})
export class MatchingPasswordValidatorDirective implements Validator {
  public readonly authMatchingPassword = input('');

  public validate(control: AbstractControl): ValidationErrors | null {
    return this.authMatchingPassword() === control.value ? null : { passwordNoMatch: true };
  }
}
